import { App } from 'antd';
import { ApiError } from '@/queries/api-client';
import { ApiErrorContent } from '../components/ApiErrorContent';
import { ApiErrorHandlerOptions } from '../types';

export const useApiErrorHandler = () => {
  const { modal } = App.useApp();

  const handleApiError = (
    error: ApiError | Error,
    options: ApiErrorHandlerOptions = {}
  ) => {
    const apiError =
      error instanceof ApiError
        ? error
        : new ApiError({
            message: error.message || 'An unexpected error occurred',
            type: 'ApiUnknownError',
            cause: error,
          });
    const {
      title,
      description,
      retryButtonText,
      showHelpButton,
      onRetry,
      modalProps = {},
    } = options;

    const defaultModalProps = {
      title: null,
      footer: null,
      width: 480,
      // centered: true,
      maskClosable: true,
      closable: true,
    };

    const finalModalProps = {
      ...defaultModalProps,
      ...modalProps,
    };

    const modalInstance = modal.error({
      ...finalModalProps,
      icon: null,
      content: (
        <ApiErrorContent
          error={apiError}
          title={title}
          description={description}
          retryButtonText={retryButtonText}
          showHelpButton={showHelpButton}
          onRetry={onRetry}
          onClose={() => modalInstance.destroy()}
        />
      ),
    });

    return modalInstance;
  };

  return { handleApiError };
};
